// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITriggerThresholdDto
 */
export interface ITriggerThresholdDto {
    /**
     * 
     * @type {number}
     * @memberof ITriggerThresholdDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITriggerThresholdDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ITriggerThresholdDto
     * @deprecated
     */
    type?: ITriggerThresholdDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ITriggerThresholdDto
     */
    trigger_category_type?: ITriggerThresholdDtoTriggerCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ITriggerThresholdDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITriggerThresholdDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof ITriggerThresholdDto
     */
    threshold_amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum ITriggerThresholdDtoTypeEnum {
    EXTERNAL_DEDUCTIBLE_MET = 'EXTERNAL_DEDUCTIBLE_MET',
    PLAN_DEDUCTIBLE_MET = 'PLAN_DEDUCTIBLE_MET',
    MEMBER_DEDUCTIBLE_MET = 'MEMBER_DEDUCTIBLE_MET',
    EMBEDDED_DEDUCTIBLE_MET = 'EMBEDDED_DEDUCTIBLE_MET'
}
/**
* @export
* @enum {string}
*/
export enum ITriggerThresholdDtoTriggerCategoryTypeEnum {
    EXTERNAL = 'EXTERNAL',
    FAMILY = 'FAMILY',
    EMBEDDED = 'EMBEDDED'
}


/**
 * Check if a given object implements the ITriggerThresholdDto interface.
 */
export function instanceOfITriggerThresholdDto(value: object): value is ITriggerThresholdDto {
    return true;
}

export function ITriggerThresholdDtoFromJSON(json: any): ITriggerThresholdDto {
    return ITriggerThresholdDtoFromJSONTyped(json, false);
}

export function ITriggerThresholdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITriggerThresholdDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'trigger_category_type': json['trigger_category_type'] == null ? undefined : json['trigger_category_type'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'threshold_amount': json['threshold_amount'] == null ? undefined : json['threshold_amount'],
    };
}

export function ITriggerThresholdDtoToJSON(json: any): ITriggerThresholdDto {
    return ITriggerThresholdDtoToJSONTyped(json, false);
}

export function ITriggerThresholdDtoToJSONTyped(value?: ITriggerThresholdDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'trigger_category_type': value['trigger_category_type'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'threshold_amount': value['threshold_amount'],
    };
}

